
<app-modal-wrapper>
  <app-modal-content
    [hiddenButtons]="['success', 'close']"
    [modalTitle]="companyType | deviceStatus"
    (closeModal)="closeModal.emit()"
  >
    <div class="modal-body" *ngIf="companyPreviewData$ | async as company">
      <div class="modal-field">
        <p i18n>Название</p>
        <p>{{ company.name }}</p>
      </div>
      <div class="modal-field">
        <p i18n>Страна</p>
        <p>{{ company.countryCode | countryAsync | async }}</p>
      </div>
      <div class="modal-field">
        <p i18n>Город</p>
        <p>{{ company.cityName }}</p>
      </div>
      <div class="modal-field">
        <p i18n>Адрес</p>
        <p>{{ company.address }}</p>
      </div>
      <div class="modal-field">
        <p i18n>Телефон</p>
        <p>{{ company.phone }}</p>
      </div>
      <div class="modal-field">
        <p>Email</p>
        <p>{{ company.email }}</p>
      </div>
      <div *ngIf="company.notes != null" class="modal-field">
        <p i18n>Заметки</p>
        <p>{{ company.notes | emptyNo }}</p>
      </div>
      <div class="modal-field">
        <a [routerLink]="companyUrl" [queryParams]="{ return: true }">Подробнее</a>
      </div>
    </div>
  </app-modal-content>
</app-modal-wrapper>
